import {
  IMG_CLASSES, IMG_ID, TEXT_ID,
} from '@whispli/loading/constants'

export const render = () => {
  document.documentElement.classList.toggle('loading')
  document.body.classList.toggle('loading')

  const el = document.createElement('div')
  el.id = 'app--loading'
  el.innerHTML = `<main id="app__main">
  <!-- @see ./src/dumb/WLogo -->
  <svg
    id="${IMG_ID}"
    width="100"
    height="100"
    class="logo"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 280.2 280.2">
    <path
      class="logo--transparent-fill ${IMG_CLASSES.join(' ')}"
      d="M143.2 13.3c2.9 2.1 4.4 4.9 4.8 8.6 2.1 19.5 4.5 38.9 6.8 58.7 6.9-3.6 13.6-7.2 20.3-10.8 19-10.2 38.1-20.3 57.1-30.5 2.9-1.6 5.4-1.2 6.7 1.1 1.4 2.7.7 4.8-1.8 6.6-23 17.7-46.1 35.5-69.1 53.2-.9.7-1.7 1.4-3.2 2.6 4.2.5 7.7 1 11.3 1.4 26.5 2.8 52.9 5.5 79.4 8.2.6.1 1.1.2 1.7.2 2.7.3 4.8 1.4 5 4.4.1 2.8-1.6 4.1-4.1 4.9-6.8 2.1-13.5 4.4-20.3 6.6-10.4 3.4-20.9 6.8-32.1 10.4 2.4 1.3 4.1 2.2 5.9 3.1 19 9.7 38.8 17.8 59.1 24.6 4.2 1.4 6.2 4.1 5.9 8.2-.2 3.5-2.6 6.4-6.1 6.9-1.7.3-3.6 0-5.2-.6-26.4-8.7-51.8-19.5-75.8-33.6-2.8-1.6-5.1-2-8.1-.9-6.1 2.2-12.4 4.1-18.9 6.2 1.1 7.7 2.2 15.3 3.3 22.9l8.4 55.8c.7 4.9-.9 8.1-4.6 9.2-3.9 1.1-6.8-.3-9.2-4.7-10.1-18.3-20.3-36.6-30.4-54.9-.6-1.1-1.2-2.1-2.2-3.7-2.3 5.7-4.5 10.9-6.4 16.1-8.5 23.5-16.8 47.1-25.4 70.6-.6 1.7-2 3.7-3.5 4.5-3.7 1.8-7.6-1.1-7.4-5.3.1-1.6.6-3.3 1.2-4.8 6.5-18.5 13-36.9 19.4-55.4.8-2.3 1-4.8 1-7.2 0-8.2-.2-16.4-.3-25-13.7 4.4-26.6 8.6-39.5 12.7-10 3.2-20.1 6.5-30.2 9.7-4.1 1.3-8.5-.4-10.2-3.9-1.8-3.6-.5-7 3.7-9.8C52 165 73.9 150.4 95.8 135.8c.9-.6 1.8-1.3 2.9-2-1.1-3.5-2.2-7-3.3-10.8-7.2 1.4-14.3 2.8-21.3 4.2-21.4 4.3-42.7 8.6-64.1 13-2.6.5-4.8.1-5.6-2.7-.7-2.5.8-4.3 4.1-4.9 25.9-5.2 51.7-10.3 77.6-15.5 2.2-.4 4.3-1 6.8-1.5-1.2-2.6-2.2-5.1-3.5-7.5C78.6 89 68 70 57.5 51.1c-1.6-2.9-1.8-5.7.2-8.4 1.9-2.5 4.7-3.6 7.4-2.4 2 .9 4.1 2.8 5.2 4.7 10.1 17.9 20.1 35.9 30.1 53.9.5.9 1.1 1.9 1.9 3.2.6-1.1 1-1.8 1.3-2.6 10-26.8 19.9-53.6 30-80.3.9-2.3 3.2-3.9 4.9-5.9h4.7zm-7.3 27.2c-.2 0-.4-.1-.7-.1-7.7 20.8-15.5 41.5-23.6 63.2 9.9-5.3 18.9-10 27.7-14.8.8-.4 1.3-2.2 1.2-3.2-.9-10-1.9-19.9-2.9-29.9-.4-5.1-1.1-10.1-1.7-15.2zm97.9 79.6c-.1-.3-.1-.6-.2-.8-22.2-2.3-44.4-4.6-66.5-7-.1.3-.3.7-.4 1 6.3 4.6 12.7 8.9 18.7 13.8 5.9 4.8 11.5 5.9 18.8 2.9 9.6-4 19.7-6.7 29.6-9.9zm-98.7 41.4c9.2 16.5 18.2 32.7 27.2 48.9.2-.1.4-.2.7-.3-2.7-18.2-5.5-36.4-8.2-54.9-6.8 2.2-13 4.2-19.7 6.3zM63 174.6c.1.2.3.3.4.5 13-4.2 26-8.4 38.9-12.7.9-.3 1.9-1.9 1.8-2.7-.4-3.6-1.3-7.1-2.1-11.2-13.2 8.9-26.1 17.5-39 26.1zm64.7-26.4c3.8-8.1 7.3-15.8 10.9-23.4-.2-.1-.4-.2-.5-.3-5.7 3.8-11.4 7.7-17.1 11.5 2.2 4.1 4.3 7.8 6.7 12.2zm22.8-20.6c-.2 0-.5-.1-.7-.1-3.6 7.5-7.1 15.1-11 23.4 5.4-1.7 9.9-3.2 14.6-4.7-1.1-6.5-2-12.6-2.9-18.6zm24.7 11.4c-5.8-4.4-11.2-8.4-17-12.8.9 6.1 1.8 11.7 2.6 17.5 4.9-1.6 9.4-3 14.4-4.7zm9.2-63l-.3-.6c-1.1.5-2.1.9-3.2 1.5-7.2 3.9-14.5 7.7-21.7 11.6-4.1 2.2-4.7 3.9-2.6 8.8 9.4-7.1 18.6-14.2 27.8-21.3zm-63.6 33.1c.1.2.2.5.3.7 5.2-1 10.4-2 15.6-3.1 6.2-1.3 6.5-2 4.8-8.7-6.9 3.8-13.8 7.4-20.7 11.1zm-6.6 69.7c.2 0 .5 0 .7.1 1.6-4 3.2-7.9 5-12.3-2 .6-3.3.8-4.5 1.4-.7.3-1.9 1-1.9 1.5 0 3 .4 6.1.7 9.3zm-3.9-32.5c-.2.1-.4.1-.6.2.8 4.2 1.6 8.3 2.4 12.8 1.6-.5 2.9-.9 4.5-1.5-2.1-4-4.2-7.7-6.3-11.5zm11.3-28c-.1-.2-.2-.5-.4-.7-3 .6-6 1.3-9.4 2 .8 1.4 1.4 2.5 2.1 3.7 2.8-1.7 5.2-3.3 7.7-5z" />
  </svg>
  <div id="${TEXT_ID}">We're getting things ready</div>
  <div id="app__error" style="display: none;">
    <h1>Browser not supported</h1>
    <div>
      <strong>Your current browser is not supported.</strong>
      <br/>
      <code id="app__error__user-agent"></code>
      <br/>
      <p>
        <!-- <span><button id="app__error__open-in-edge" style="display:none;">Open in Microsoft Edge</button></span> -->
        Please update your browser to the latest version to continue.
      </p>
      <ul>
        <li>Google Chrome <a href="https://google.com/chrome/browser/desktop" target="_blank">https://google.com/chrome/browser/desktop</a></li>
        <li>Microsoft Edge <a href="https://microsoft.com/windows/microsoft-edge" target="_blank">https://microsoft.com/windows/microsoft-edge</a></li>
        <li>Mozilla Firefox <a href="https://mozilla.org/firefox" target="_blank">https://mozilla.org/firefox</a></li>
      </ul>
      <div id="app__error__text"></div>
    </div>
  </div>
</main>`

  ;(document.getElementById('app') as HTMLElement).replaceChildren(el)
}

export const renderError = (error: string) => {
  const img = document.getElementById(IMG_ID)
  if (img) {
    img.querySelector('path')?.classList.remove(...IMG_CLASSES)
  }

  const text = document.getElementById(TEXT_ID)
  if (text) {
    text.innerText = `Something went wrong. Could not load application.\n${error}`
  }
}
